module.exports = __webpack_public_path__ + "img/香薷.a72a292a.jpg";